var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryOptionsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4548_1376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85018 5.21046C6.57077 5.48988 6.57077 5.94124 6.85018 6.22065L9.62998 9.00045L6.85018 11.7802C6.57077 12.0597 6.57077 12.511 6.85018 12.7904C7.1296 13.0698 7.58096 13.0698 7.86038 12.7904L11.1489 9.50196C11.4283 9.22255 11.4283 8.77119 11.1489 8.49177L7.86038 5.2033C7.58812 4.93105 7.1296 4.93105 6.85018 5.21046Z",
    fill: "#002677"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4548_1376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    fill: "white",
    transform: "translate(6.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryOptionsArrow);
export default __webpack_public_path__ + "static/media/SummaryOptionsArrow.79bc964d7185903b8550ed55b63495f9.svg";
export { ForwardRef as ReactComponent };